import {Component, Input, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-content-dialog',
    templateUrl: './app-content-dialog.component.html',
    styleUrls: ['./app-content-dialog.component.scss']
})
export class AppContentDialogComponentMT {
    @Input() htmlContent: string ='';
    @Input() templateRef: TemplateRef<any>|null=null;
}
